<template>
    <div class="personnel-authority-wrap">
        <ul class="custom-tabbar">
            <li v-for="(tabItem, tabIndex) in tabList" :key="tabIndex" @click="handleClickTab(tabItem.name)" :class="{ active: tabItem.name == activeName }">
                <span>{{ tabItem.label }}</span>
            </li>
        </ul>
        <div class="personnel-authority-content">
            <template v-if="activeName == 'manager'">
                <PersonnelManager ref="PersonnelManager" />
            </template>
            <template v-else>
                <MemberPermissions ref="MemberPermissions" />
            </template>
        </div>
    </div>
</template>
<script>
import PersonnelManager from "./personnel_manager.vue";
import MemberPermissions from "./member_permissions.vue";

export default {
    name: "PersonnelAuthority",
    components: { PersonnelManager, MemberPermissions },
    data() {
        return {
            activeName: "manager",
            tabList: [
                { name: "manager", label: "人事管理员" },
                { name: "authority", label: "成员权限" },
            ],


        };
    },
    methods: {
        handleClickTab(name) {
            this.activeName = name;
            this.$nextTick(() => {
                if (this.activeName == 'manager') {

                } else {

                }
            })

        },

    },
};
</script>
<style lang="scss" scoped>
.personnel-authority-wrap {
    .personnel-authority-content {
        padding: 16px;
    }
}
</style>
<style lang="scss">
.custom-tabbar {
    position: relative;
    padding: 0 16px;
    border-bottom: 1px solid #e8e8e8;

    li {
        display: inline-block;
        vertical-align: top;
        height: 48px;
        line-height: 48px;
        padding: 0 16px;
        position: relative;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;

        &.active {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            color: rgba(41, 144, 255, 1);

            &::after {
                content: "";
                display: block;
                position: absolute;
                left: 0;
                right: 0;
                width: 100%;
                bottom: 0;
                height: 2px;
                opacity: 1;
                background: #2990ff;
            }
        }
    }
}

.user-avatar-tag {
    min-width: 70px;
    height: 22px;
    box-sizing: border-box;
    line-height: 22px;
    border-radius: 11px;
    display: inline-block;
    cursor: pointer;
    vertical-align: middle;

    &:hover,&:active {
        background-color: rgb(237, 240, 244);
        color: rgba(51, 51, 51, 1);
    }

    img {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        object-fit: cover;
        vertical-align: top;
    }

    span {
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        height: 22px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        padding: 0 12px 0 8px;
    }
}
</style>
